module.exports = __webpack_public_path__ + "media/images/v3/thumb3-e6269647d09e3638497ebe243929d1a5.jpg";